module.exports = __webpack_public_path__ + "static/media/MR.aa72dd9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MR.svg
// module id = 2213
// module chunks = 7